import { render } from "./manager_rate_change.vue?vue&type=template&id=670cfc0c"
import script from "./manager_rate_change.vue?vue&type=script&lang=js"
export * from "./manager_rate_change.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hitenradadiya/Front/shiv_mfg_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__